import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LoginOutlined,
  ThunderboltOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';

import {
  Button,
  Col,
  Divider,
  Badge,
  Input,
  Popover,
  Radio,
  Row,
  Switch,
  Table,
  Tooltip,
  Tag,
  Tree,
} from 'antd';
import moment from 'moment';
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'dva';
import { makeSuppressObj } from '../../utils/suppressionHelper';
import FinderSuppressReason from './components/FinderSuppressReason';
import EmptyData from './EmptyData';
import styles from './index.less';
import { userCan } from '@/utils/authority';
import { data } from './components/Resource/RiskTypeData';
import RenderDot from '../WidgetWrapper/widgets/components/RenderDot';
import { MapToObject } from './components/Resource/Utils/MapToObject';
import { awsData } from './components/Resource/RisksDummyData';
import { capitalizeFirstLetter } from '../../helpers/capitalizeFirstLetter';
import {
  CheckDuplicateNoOfString,
  CheckDuplicateString,
} from './components/Resource/Utils/CheckDuplicateString';
import { getColorBySeverity } from '../RiskCard/helpers';
import { riskTypes } from '@/utils/constant';
import { compareStrings, isSuppressionDisabled } from '@/utils/utils';

const { TreeNode } = Tree;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};
/**
 * @to-do: report generated on time/date
 */
const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

@connect(({ singleRisk, organisation }) => ({
  riskName: singleRisk.riskName,
  riskTypes: singleRisk.riskTypes,
  packageExpiry: organisation.packageExpiry,
}))
class SingleResourceTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      inputVal: '',
      value: 'Not Applicable',
      selectedRowKeys: [],
      showSuppress: false,
      suppressRisksCount: 0,
      filteredInfo: null,
      riskVisible: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.riskName !== prevProps.riskName) {
      this.setState({
        filteredInfo: {
          type: this.props.riskName,
        },
      });
    }
    if (prevProps.supLoading && !this.props.supLoading) {
      this.setState({
        selectedRowKeys: [],
      });
    }
  }

  render() {
    let { resourceRisks, drawerLoading, showSuppress, malwares, osVulnerabilities } = this.props;

    let locale;

    if (resourceRisks !== null) {
      locale = {
        emptyText: <EmptyData type="singleResource" />,
      };
    }

    const { selectedRowKeys } = this.state;
    const { packageExpiry } = this.props;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      // Column configuration not to be checked if the type is osVulnerabilities or malware or the risk is suppress already
      getCheckboxProps: record => ({
        disabled:
          packageExpiry === 'expired' ||
          record?.suppress ||
          record.hasOwnProperty('cloudXRayRisks') ||
          compareStrings(record?.type, riskTypes.osVulnerabilities) ||
          compareStrings(record?.type, riskTypes.malware) ||
          compareStrings(record?.riskType, riskTypes.osVulnerabilities) ||
          compareStrings(record?.riskType, riskTypes.malware),

        suppress:
          record?.suppress ||
          record.hasOwnProperty('cloudXRayRisks') ||
          compareStrings(record?.type, riskTypes.osVulnerabilities) ||
          compareStrings(record?.type, riskTypes.malware) ||
          compareStrings(record?.riskType, riskTypes.osVulnerabilities) ||
          compareStrings(record?.riskType, riskTypes.malware),
      }),
    };

    const columns = this.getColumns();

    const hasSelected = selectedRowKeys.length > 0;
    let tableHeight = window.screen.availHeight - 400;

    let risks = resourceRisks;

    if (!showSuppress) {
      risks = getUnSuppressedRisks(risks);
    }

    let newRisk = [];

    //  * spread all the risks into a new array that is risks, malwares, osVulnerabilities but only spread if these are arrays if they are undefined then spread others which are arrays
    if (risks) {
      newRisk = [...risks];
    }
    if (malwares) {
      newRisk = [...newRisk, ...malwares];
    }
    if (osVulnerabilities) {
      newRisk = [...newRisk, ...osVulnerabilities];
    }

    // * sort the new array by severity
    newRisk = sortData(newRisk);

    return (
      <Fragment>
        <Row>
          <Col span={10}>
            {hasSelected && (
              <div style={{ marginBottom: 16 }}>
                <span style={{ marginLeft: 8, color: '#1890FF' }}>
                  <ExclamationCircleOutlined
                    style={{ fontSize: 20, marginLeft: 10, marginRight: 10 }}
                  />

                  {hasSelected ? `${selectedRowKeys.length} Risk(s) selected ` : ''}
                </span>
                <Button
                  type="default"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    this.setState({
                      selectedRowKeys: [],
                    });
                  }}
                  disabled={!hasSelected}
                >
                  Cancel
                </Button>
                <Popover
                  placement="bottomRight"
                  style={{ width: '40px' }}
                  key="this.props.i"
                  content={this.RenderPopoverContent()}
                  title="Suppress these risks"
                  trigger="click"
                  visible={this.state.visible}
                >
                  <Button
                    type="primary"
                    loading={this.props.supLoading}
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      this.setState({
                        visible: true,
                      });
                    }}
                    disabled={!hasSelected}
                  >
                    Suppress
                  </Button>
                </Popover>
              </div>
            )}
          </Col>
        </Row>

        <Table
          columns={columns}
          // scroll={{ y: 'calc(100vh - 360px)' }}
          loading={drawerLoading}
          // locale={!drawerLoading && locale}
          rowClassName={record => {
            return record.suppress ? styles.tableRow : '';
          }}
          // pagination={false}
          pagination={true}
          rowSelection={rowSelection}
          rowKey={record => record.signatureName || record.title || record.cveID}
          // dataSource={risks}
          //TODO
          dataSource={newRisk}
          onChange={this.handleChange}
        />
      </Fragment>
    );
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
    });
  };

  // filtering signaturesNames
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    e => this.setState({ searchText: e.target.selectedKeys[0] });
  };

  // selected value willbe reset
  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({
      filteredInfo: null,
      sortedInfo: null,
    });
    e => this.setState({ searchText: '' });
  };

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  stringSplit = (title, limit) => {
    const titleSlice = title.slice(0, limit);
    const spaceIndex = titleSlice.lastIndexOf(' ');
    const str = titleSlice.slice(0, spaceIndex);
    return str;
  };

  RenderPopoverContent = () => {
    return (
      <div style={{ width: '248px' }}>
        <Radio.Group
          onChange={e => {
            this.setState({
              value: e.target.value,
            });
          }}
          value={this.state.value}
        >
          <Radio style={radioStyle} value="Not Applicable">
            Not Applicable
          </Radio>
          <Divider style={{ margin: '9px 0px' }} />
          <Radio style={radioStyle} value="Not in Scope">
            Not in Scope
          </Radio>
          <Divider style={{ margin: '9px 0px' }} />
          <Radio style={radioStyle} value={this.state.inputVal}>
            <Input
              onChange={e => {
                this.setState({
                  value: e.target.value,
                  inputVal: e.target.value,
                });
              }}
              placeholder="Other reason"
              style={{ width: '170px' }}
              type="text"
            />
          </Radio>
        </Radio.Group>
        <div style={{ marginLeft: '57px', marginTop: '17px' }}>
          <Button
            onClick={() => {
              this.setState({
                visible: false,
              });
            }}
          >
            Cancel
          </Button>
          <Button
            loading={this.props.supLoading}
            onClick={this.multipleSuppress}
            type="primary"
            style={{ marginLeft: '4px' }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  };

  RanderTagForType = type => {
    // *@@@@
    //  ?? check type and return tag
    //  ?? if the type is not in the list then return not available tag with specific style
    // *@@@@

    if (type) {
      const typeAsLowerCase = type?.toLowerCase();
      // * remove space from key above variable
      const typeWithoutSpace = typeAsLowerCase?.replace(/\s/g, '');
      // * change all the keys in data object to lowercase and create a new object with the new keys and the same values
      const dataKeysInLowerCase = Object.keys(data).reduce((acc, key) => {
        acc[key.toLowerCase()] = data[key];
        return acc;
      }, {});
      // * get the key value from the data object that is same as the key without space above, but remember we hvae key with out space in lowercase
      const typeValue = dataKeysInLowerCase[typeWithoutSpace];
      return <Tag style={typeValue?.style}>{typeValue?.name}</Tag>;
    } else {
      return <Tag style={data.NA.style}>N/A</Tag>;
    }
  };

  RenderTagForSeverty = (type, record) => {
    const riskStatus = (record.risk || record.severity || record.cvss3Severity).toLowerCase();
    return (
      <Tag color={getColorBySeverity(riskStatus)}>
        <span>{riskStatus === 'n/a' ? 'N/A' : capitalizeFirstLetter(riskStatus) || '-'}</span>
      </Tag>
    );
  };

  getColumns = () => {
    // TODO: Add data of cloudXray on this table
    const { filteredInfo } = this.state;
    const cols = [
      {
        title: 'Issue',
        dataIndex: 'messageFail',
        key: 'messageFail',
        width: 500,
        render: (text, record) => {
          let lastSeen = record?.lastSeen || record?.end_date || record?.reportedAt;
          let firstSeen = record?.firstSeen || record?.start_date || record?.scannedAt;
          // let creationOfRisk = record?.creationOfRisk;

          let lastSeenTime;
          let firstSeenTime;

          if (lastSeen && firstSeen) {
            lastSeenTime = lastSeen.toDate
              ? moment(lastSeen.toDate()).fromNow()
              : moment(new Date(lastSeen?._seconds * 1000)).fromNow();

            firstSeenTime = firstSeen.toDate
              ? moment(firstSeen?.toDate()).format('MMM Do, YYYY hh:mm a')
              : moment(new Date(firstSeen?._seconds * 1000)).format('MMM Do, YYYY hh:mm a');

            firstSeen = firstSeen.toDate
              ? moment(firstSeen.toDate()).fromNow()
              : moment(new Date(firstSeen?._seconds * 1000)).fromNow();
          } else {
            lastSeenTime = 'N/A';
            firstSeenTime = 'N/A';
          }

          return (
            <span
              style={{
                cursor: 'pointer',
              }}
            >
              <div style={{ fontWeight: 500, marginBottom: '0px' }}>
                <div
                  onClick={e => {
                    e.stopPropagation();
                    let signatureName = '';
                    if (record.hasOwnProperty('cveID')) {
                      signatureName = record?.cveID;
                    } else if (record.hasOwnProperty('malwareId')) {
                      signatureName = record?.malwareId;
                    } else {
                      signatureName = record?.signatureName;
                    }
                    // drawer params on click
                    let drawerParams = [
                      {
                        type: 'signatureName',
                        value: [signatureName],
                      },
                    ];
                    // return;
                    this.props.openDrawer(drawerParams, 'signatureDrawer', false, record);
                  }}
                >
                  {record.messageFail
                    ? record?.messageFail
                    : record.cveID
                    ? this.stringSplit(record?.title, 100)
                    : `${record?.title} Found` || ''}
                  <p style={{ marginLeft: '8px', display: 'inline-block' }}>
                    <LoginOutlined
                      onClick={e => {
                        e.stopPropagation();
                        let signatureName = '';
                        if (record.hasOwnProperty('cveID')) {
                          signatureName = record?.cveID;
                        } else if (record.hasOwnProperty('malwareId')) {
                          signatureName = record?.malwareId;
                        } else {
                          signatureName = record?.signatureName;
                        }
                        // drawer params on click
                        let drawerParams = [
                          {
                            type: 'signatureName',
                            value: [signatureName],
                          },
                        ];
                        // return;
                        this.props.openDrawer(drawerParams, 'signatureDrawer', false, record);
                      }}
                      style={{ color: '#1890FF' }}
                    />
                  </p>
                </div>
              </div>

              <div
                style={{
                  marginTop: -14,
                  marginBottom: -8,
                  fontSize: '12px',
                  color: ' #8C8C8C',
                  fontWeight: 400,
                }}
              >
                <Tooltip
                  title={`Signature ID: ${record?.signatureName || record?.cveID || record?.title}`}
                >
                  {record.dataSource ? (
                    <span>
                      <DatabaseOutlined style={{ fontSize: '13px', marginRight: '3px' }} />
                      {record.dataSource}
                    </span>
                  ) : (
                    ''
                  )}{' '}
                  <ThunderboltOutlined style={{ fontSize: '13px' }} />
                  {` `}
                  {record?.signatureName || record?.cveID || record?.title}
                </Tooltip>
                <Tooltip title={`First Seen: ${firstSeenTime}`}>
                  <ClockCircleOutlined style={{ marginLeft: '12px', fontSize: '13px' }} />
                  {` `}
                  {firstSeen}
                </Tooltip>
              </div>
            </span>
          );
        },
        filteredValue: filteredInfo?.messageFail ? filteredInfo.messageFail : null,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div
            style={{
              padding: '8px',
              borderRadius: '6px',
              background: '#fff',

              boxShadow: '0 1px 6px rgba(0, 0, 0, 0.2)',
            }}
          >
            <Input
              style={{ marginBottom: '10px' }}
              ref={ele => (this.searchInput = ele)}
              placeholder="Search Risk"
              value={selectedKeys}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={this.handleSearch(selectedKeys, confirm)}
            />
            <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
              Search
            </Button>
            <Button
              style={{
                marginLeft: '10px',
              }}
              onClick={this.handleReset(clearFilters)}
            >
              Reset
            </Button>
          </div>
        ),

        onFilter: (value, record) =>
          `${record.name} ${record.messageFail}`.toLowerCase().includes(value.toLowerCase()),
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: 140,
        render: type => this.RanderTagForType(type),
        filteredValue: filteredInfo?.type ? filteredInfo.type : null,
        filters: [
          {
            text: 'Malware',
            value: 'Malware',
          },
          {
            text: 'Data At Risk',
            value: 'Data At Risk',
          },
          {
            text: 'Authentications',
            value: 'Authentications',
          },
          {
            text: 'IAM Misconfigurations',
            value: 'IAM Misconfigurations',
          },
          {
            text: 'Vulnerabilities',
            value: 'Vulnerabilities',
          },
          {
            text: 'Lateral Movement',
            value: 'Lateral Movement',
          },
          {
            text: 'Neglected Assets',
            value: 'Neglected Assets',
          },
          {
            text: 'OS Vulnerabilities',
            value: 'OS Vulnerabilities',
          },
          {
            text: 'Third Party Risks',
            value: 'Third Party Risks',
          },
        ],

        onFilter: (value, record) => {
          return record.type?.toLowerCase() === value.toLowerCase();
        },
      },
      {
        title: 'Severity',
        dataIndex: 'risk' || 'status',
        key: 'risk' || 'status',
        width: 100,
        render: (text, record) => this.RenderTagForSeverty(text, record),

        filteredValue: filteredInfo?.risk ? filteredInfo.risk : null,
        filters: [
          {
            text: 'Critical',
            value: 'Critical',
          },
          {
            text: 'High',
            value: 'High',
          },
          {
            text: 'Medium',
            value: 'Medium',
          },
          {
            text: 'Low',
            value: 'Low',
          },
        ],

        onFilter: (value, record) =>
          record?.risk
            ? record?.risk?.toLowerCase() === value?.toLowerCase()
            : record.cvss3Severity?.toLowerCase() === value?.toLowerCase(),
        sorter: (a, b) => a?.risk?.length - b?.risk?.length,
        sortDirections: ['ascend'],
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (status, record) => {
          let lastSeen = record?.lastSeen || record?.end_date || record?.reportedAt;
          let lastSeenTime;

          if (lastSeen) {
            lastSeenTime = lastSeen.toDate
              ? moment(lastSeen?.toDate()).format('MMM Do, YYYY hh:mm a')
              : moment(new Date(lastSeen?._seconds * 1000)).format('MMM Do, YYYY hh:mm a');
          } else {
            lastSeenTime = 'N/A';
          }

          return (
            <Tooltip title={`Last Scanned: ${lastSeenTime}`}>
              {status?.toLowerCase() === 'pass' ? (
                <CheckCircleOutlined
                  style={{ marginLeft: '10px', color: '#3ADFA3', fontSize: 25 }}
                />
              ) : (
                <CloseCircleOutlined
                  style={{ marginLeft: '10px', color: '#F4657C', fontSize: 25 }}
                />
              )}
            </Tooltip>
          );
        },
      },
      {
        title: 'Suppress',
        dataIndex: 'suppress',
        key: 'suppress',
        width: 100,
        render: (name, record, i) => {
          let suppressProps = {
            i,
            type: 'risk',
            record,
            disabled: isSuppressionDisabled(record),
          };
          return (
            <div style={{ paddingLeft: '20%' }}>
              <FinderSuppressReason {...suppressProps} />
            </div>
          );
        },
      },
    ];
    return cols;
  };

  multipleSuppress = () => {
    this.setState({
      visible: false,
    });

    let { selectedRowKeys } = this.state;

    const { dispatch, currentUser, resourceRisks } = this.props;

    let risks = resourceRisks;

    let data = selectedRowKeys.map(v => {
      let record = risks.find(r => r.signatureName === v);
      let params = {
        cloudAccount: record.cloudAccountId,
        resourceId: record.resourceId || '.*',
        signatureName: record.signatureName || '.*',
        regulationId: '.*',
        createdBy: currentUser.name || '',
        reason: this.state.value,
      };
      let suppressObj = makeSuppressObj(params);

      return suppressObj;
    });

    if (data.length > 0) {
      userCan('create-suppress', () => {
        dispatch({
          type: 'suppression/createSuppress',
          payload: {
            suppressionData: data,
          },
        });
      })();
    }
  };
}

export default SingleResourceTable;

function getUnSuppressedRisks(data) {
  return data.filter(v => v.suppress === false);
}

function sortData(data) {
  const sortedBySeverityData = sortRiskBasedOnSeverity(data);
  const sortedRiskData = sortRiskBasedOnFirstSeen(sortedBySeverityData);
  return sortedRiskData;
}

// ~ create a function that will sort risk based on there severity, critical, high, medium, low and then by status pass or fail, fail first then pass
// ~ it should be like this, fail critical, fail high, fail medium, fail low, pass critical, pass high, pass medium, pass low
function sortRiskBasedOnSeverity(data) {
  const sortedData = data.sort((a, b) => {
    const riskA = (a.risk || a.severity || a.cvss3Severity).toLowerCase();
    const riskB = (b.risk || b.severity || b.cvss3Severity).toLowerCase();
    if (riskA === riskB) {
      return a.status === 'fail' ? -1 : 1;
    }
    if (riskA === 'critical') {
      return -1;
    }
    if (riskB === 'critical') {
      return 1;
    }
    if (riskA === 'high') {
      return -1;
    }
    if (riskB === 'high') {
      return 1;
    }
    if (riskA === 'medium') {
      return -1;
    }
    if (riskB === 'medium') {
      return 1;
    }
    if (riskA === 'low') {
      return -1;
    }
    if (riskB === 'low') {
      return 1;
    }
  });
  return sortedData;
}

// ~ create a function that will sort risk based on there first seen, first seen has nano second and seconds, so first convert it into date and then sort it the oldest first seen date will be on top

const sortRiskBasedOnFirstSeen = data => {
  const sortedData = data.sort((a, b) => {
    const dateA = new Date(a.firstSeen);
    const dateB = new Date(b.firstSeen);
    return dateA - dateB;
  });
  return sortedData;
};
